import { ADD_USER_ACTION, REMOVE_USER_ACTION, ADD_USER_AVATAR } from "redux/reducers/userReducer"

export const addUserAction = (user) => {
    return {
        type: ADD_USER_ACTION,
        payload: user
    }
}

export const removeUserAction = () => {
    return {
        type: REMOVE_USER_ACTION,
        payload: null
    }
}

export const addUserAvatar = (data) => {
    return {
        type: ADD_USER_AVATAR,
        payload: data
    }
}
